{
  "title": "Fournir une preuve de l'identité",
  "client": "Client",
  "relationshipTo": "Relation avec {{whom}} (membre principal)",
  "continue": "Continuer",
  "updated": "Le membre du ménage {{memberName}} a été mis à jour.",
  "save": "Enregistrer",
  "documentType": "Type de document",
  "methodOfIDVerification": "Méthode de vérification de l'identité",
  "informationSource": "Source d'information",
  "informationType": "Type d'information",
  "documentID": "Référence du document",
  "documentIDSingle": "Identifiant du document",
  "userName": "Nom figurant sur la pièce d'identité",
  "secondaryUserName": "Nom figurant sur la pièce d'identité",
  "informationSourceSingle": "Territoire d'émission du document",
  "verifiedDate": "Date de vérification",
  "expiryDate": "Date d'expiration",
  "nextDocument": "Document suivant",
  "saveDoc1": "Enregistrement du document 1 sur 2",
  "saveDoc2": "Enregistrement du document 2 sur 2",
  "firstPageStepSingleMethod": "ÉTAPE 1 sur 1",
  "firstPageStepDualMethod": "ÉTAPE 1 sur 2",
  "secondPageStepDualMethod": "ÉTAPE 2 sur 2",
  "summaryTitle": "Fournir une preuve de l'identité",
  "documentName": "Nom du document",
  "documentsUploaded": "2 documents téléchargés",
  "documentUploaded": "1 document téléchargé",
  "noDocumentUploaded": "Aucun document téléchargé",
  "noOptionsText": "Saisir un nouveau territoire"
}
